const BASE = "/api/v1/soccer";
const PASSCODE_KEY = "soccer-passcode";

let passcode = "";
try { passcode = localStorage.getItem(PASSCODE_KEY) || ""; } catch (e) {}

export function getPasscode() { return passcode; }

export function setPasscode(v) {
  passcode = v || "";
  try {
    if (passcode) localStorage.setItem(PASSCODE_KEY, passcode);
    else localStorage.removeItem(PASSCODE_KEY);
  } catch (e) {}
}

async function req(method, path, body) {
  const res = await fetch(BASE + path, {
    method,
    headers: { "Content-Type": "application/json", "X-Soccer-Passcode": passcode },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  let data = null;
  const text = await res.text();
  try { data = text ? JSON.parse(text) : null; } catch (e) {}
  if (res.status === 401) {
    const e = new Error("That passcode was not accepted.");
    e.unauthorized = true;
    throw e;
  }
  if (!res.ok) throw new Error((data && data.error) || "Request failed (" + res.status + ")");
  return data;
}

const api = {
  players: () => req("GET", "/players"),
  addPlayer: p => req("POST", "/players", p),
  editPlayer: (id, patch) => req("PATCH", "/players/" + id, patch),
  removePlayer: id => req("DELETE", "/players/" + id),

  games: () => req("GET", "/games"),
  currentGame: () => req("GET", "/games/current"),
  game: date => req("GET", "/games/" + date),
  version: date => req("GET", "/games/" + date + "/version"),
  createGame: date => req("POST", "/games", { id: date }),
  removeGame: date => req("DELETE", "/games/" + date),
  saveState: (date, state) => req("PUT", "/games/" + date + "/state", state),
};

export default api;
